import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { isRenderingForMobileApp } from 'src/constants';
import { OAuthService } from 'angular-oauth2-oidc';
import { HeaderMenuItem } from '~components/header-menu-item/header-menu-item.component';

type Tab = 'customer' | 'business';

@Component({
  selector: 'zip-co-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public isMobileRender: boolean = isRenderingForMobileApp;
  public isMenuActive: boolean = false;
  public tab: Tab = 'customer';

  public customerMenu: HeaderMenuItem[] = [
    {
      id: 'how-zip-works',
      label: 'How Zip Works',
      items: [
        {
          label: 'Use Zip just about everywhere',
          caption: 'Instore and online',
          link: '/au/how-zip-works',
          iconSrc: '/au/giftcards/assets/zip-logo-cursor.svg',
          featured: true,
        },
        {
          label: 'Accounts',
          items: [
            {
              label: 'Zip Pay',
              caption: 'Everyday account',
              link: '/au/zip-pay',
              iconSrc: '/au/giftcards/assets/zip-pay.svg',
            },
            {
              label: 'Zip Plus',
              caption: 'No interest or low interest account',
              link: '/au/zip-plus',
              iconSrc: '/au/giftcards/assets/dollar-coin.svg',
            },
            {
              label: 'Zip Money',
              caption: 'Large purchases amount',
              link: '/au/zip-money',
              iconSrc: '/au/giftcards/assets/zip-money.svg',
            },
          ],
        },
      ],
    },
    {
      id: 'shop',
      label: 'Shop',
      items: [
        {
          label: 'Use Zip just about everywhere',
          caption: 'Instore and online',
          link: '/au/how-zip-works',
          iconSrc: '/au/giftcards/assets/zip-logo-cursor.svg',
          featured: true,
        },
        {
          topLabel: 'Shop',
          label: 'Store Directory',
          caption: 'Find a store',
          link: '/au/shop',
          iconSrc: '/au/giftcards/assets/shopping-bag.svg',
        },
        {
          label: 'Gift Cards',
          caption: 'Give the gift of choice',
          link: '/au/giftcards/',
          iconSrc: '/au/giftcards/assets/gift-cards.svg',
        },
        {
          label: 'Cashback',
          caption: 'Online and instore cashback deals',
          link: '/au/shop/cashback',
          iconSrc: '/au/giftcards/assets/rewards.svg',
        },
        {
          label: 'Ways to Pay',
          items: [
            {
              label: 'Tap to pay with Zip',
              caption: 'Shop almost everywhere instore',
              link: '/au/tap-zip',
              iconSrc: '/au/giftcards/assets/tap-zip.svg',
            },
            {
              label: 'Single-use card',
              caption: 'Shop almost everywhere online',
              link: '/au/single-use-card',
              iconSrc: '/au/giftcards/assets/single-use-card.svg',
            },
          ],
        },
      ],
    },
    {
      id: 'manage',
      label: 'Manage',
      items: [
        {
          label: 'Bills',
          items: [
            {
              label: 'Pay Bills',
              caption: 'Pay your BPAY® Billers',
              link: '/au/bills',
              iconSrc: '/au/giftcards/assets/pay-bills.svg',
            },
            {
              label: 'Product Protection',
              caption: 'Insurance for your protection',
              link: '/au/product-protection',
              iconSrc: '/au/giftcards/assets/umbrella.svg',
            },
          ],
        },
      ],
    },
    {
      id: 'help',
      label: 'Help',
      link: 'https://help.zip.co/hc/en-us',
    },
  ];

  public businessMenu: HeaderMenuItem[] = [
    {
      id: 'accept-zip-payments',
      label: 'Accept Zip Payments',
      items: [
        {
          label: 'Zip Payments',
          caption: 'Make Zip a payment choice for your customers',
          link: '/au/business/payments',
          iconSrc: '/au/giftcards/assets/business-payments.svg',
        },
      ],
    },
    {
      id: 'offers',
      label: 'Offers',
      items: [
        {
          label: 'Zip Business Loan',
          caption: 'Powered by Prospa',
          link: '/au/business/prospa-loan',
          iconSrc: '/au/giftcards/assets/zip-money.svg',
        },
      ],
    },
  ];

  constructor(private oAuthService: OAuthService, private location: Location) {}

  public toggleMenu() {
    this.isMenuActive = !this.isMenuActive;
  }

  public switchTab(tab: Tab) {
    this.tab = tab;
  }

  public signIn() {
    this.oAuthService.initLoginFlow(this.location.path());
  }
}
